module.exports = __webpack_public_path__ + "img/9788992711470.e374e3ca.jpg";